// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3WBla","alert":"SettungsInbox_alert__96ru0"};